import React from "react";
import styled from "styled-components";

const Container = styled.div`
  font-family: Arial, sans-serif;
  line-height: 1.6;
  padding: 20px;
  a{
    color:black
  }

  @media (max-width: 600px) {
    padding: 16px;
  }
`;

const Centered = styled.div`
  text-align: center;
  margin-top: 20px;

  @media (max-width: 600px) {
    margin-top: 16px;
  }
`;

const Logo = styled.img`
  max-width: 100%;
  height: auto;
  width: 120px;

  @media (max-width: 600px) {
    width: 100px;
  }
`;

const Section = styled.section`
  margin: 40px 0;

  @media (max-width: 600px) {
    margin: 24px 0;
  }
`;

const Title = styled.h2`
  margin-bottom: 10px;
  font-size: 1.75rem;

  @media (max-width: 600px) {
    font-size: 1.2rem;
  }
`;

const SubTitle = styled.h3`
  margin: 10px 0;
  font-size: 1.3rem;

  @media (max-width: 600px) {
    font-size: 1rem;
  }
`;

const List = styled.ul`
  padding-left: 20px;

  @media (max-width: 600px) {
    padding-left: 16px;
  }
`;

const OrderedList = styled.ol`
  padding-left: 20px;

  @media (max-width: 600px) {
    padding-left: 16px;
  }
`;

const Email = styled.a`
  word-break: break-word;
  display: inline-block;
  color: black;

  @media (max-width: 600px) {
    font-size: 0.7rem;
  }
`;

const RewardZoo = () => {
  return (
    <Container>
      {/* App Logo */}
      <Centered>
        <Logo
          src="https://play-lh.googleusercontent.com/l6XQfhKw5vYMLjV2CM8Ur9gwx44-Cr40Uhc_qv4VuqZjvbBLqQ46Dk36f-e3UiuVbwU0=w240-h480-rw"
          alt="RewardZoo Logo"
        />
        <Title>Earn Real Rewards with RewardZoo</Title>
        <p>
          Complete tasks, surveys, and more to earn rewards you can redeem
          securely via UPI or Paytm.
        </p>
        <p>Product developed by</p>
        <SubTitle>CashCoin</SubTitle> and operated by{" "}
        <SubTitle>LEADMINT TECHNOLOGIES PRIVATE LIMITED</SubTitle>
          <p
          onClick={()=>window.open("https://play.google.com/store/apps/details?id=com.loftlime.rewardzoo&pcampaignid=web_share","_ blank")}
            style={{
              textDecoration: "underline",
              color: "blue",
              marginTop: "15px",
              width: "fit-content",
            margin: "0 auto",
            cursor: "pointer",
            }}
          >
            View the app
          </p>
      </Centered>

      {/* Welcome Section */}
      <Section>
        <h1>Welcome to RewardZoo</h1>
        <p>
          Earn Real Rewards, Seamlessly! RewardZoo is a virtual rewards platform
          developed by <strong>CashCoin</strong> and operated under the legal
          and compliance of{" "}
          <strong>LEADMINT TECHNOLOGIES PRIVATE LIMITED</strong>. Our platform
          bridges the gap between advertisers and users by offering rewards for
          completing tasks, surveys, and watching advertisements.
        </p>
      </Section>

      {/* Business Model Section */}
      <Section>
        <Title>Our Business Model</Title>
        <p>
          <strong>RewardZoo</strong> operates on a mutually beneficial business
          model that connects advertisers with engaged users while providing
          real rewards for user participation. Here's how it works:
        </p>
        <SubTitle>For Advertisers:</SubTitle>
        <List>
          <li>
            Advertisers partner with RewardZoo to promote their products,
            services, or conduct market research.
          </li>
          <li>
            Tasks such as surveys, ad views, app installations, and feedback
            collection are designed to meet advertisers' goals.
          </li>
          <li>
            Advertisers pay RewardZoo for user engagement, data insights, and
            conversions.
          </li>
        </List>
        <SubTitle>For Users:</SubTitle>
        <List>
          <li>
            Users participate in tasks like surveys, watching advertisements,
            and completing activities within the app.
          </li>
          <li>
            Each completed task earns points, which are accumulated in the
            user’s RewardZoo account.
          </li>
          <li>
            Users redeem points securely into UPI or Paytm wallets as real
            monetary rewards.
          </li>
        </List>
        <SubTitle>For Us (Platform Operations):</SubTitle>
        <List>
          <li>
            RewardZoo ensures a secure, compliant, and transparent environment
            for all transactions.
          </li>
          <li>
            Revenue generated from advertisers is shared with users in the form
            of rewards, creating a win-win ecosystem.
          </li>
          <li>
            The platform is maintained by <strong>CashCoin</strong>,
            while <strong>LEADMINT TECHNOLOGIES PRIVATE LIMITED</strong> manages
            financial compliance and legal operations.
          </li>
        </List>
        <p>
          This holistic approach ensures that advertisers achieve their
          objectives, users benefit financially, and RewardZoo operates
          sustainably.
        </p>
      </Section>

      {/* Compliance Section */}
      <Section>
        <Title>Compliance with RBI Guidelines</Title>
        <p>
          RewardZoo adheres to the{" "}
          <strong>Reserve Bank of India (RBI) Master Directions</strong> on
          Prepaid Payment Instruments (PPIs). Here's how we ensure compliance:
        </p>
        <List>
          <li>
            <strong>Semi-Closed Prepaid Payment Instrument (PPI):</strong>{" "}
            Rewards are processed securely through RBI-compliant channels like
            UPI and Paytm.
          </li>
          <li>
            <strong>Traceability and Fraud Prevention:</strong> All financial
            transactions are traceable and align with RBI’s fraud prevention
            protocols.
          </li>
          <li>
            <strong>Transparency in Operations:</strong> Managed by LEADMINT
            TECHNOLOGIES PRIVATE LIMITED, we adhere to RBI guidelines and best
            practices in the rewards industry.
          </li>
        </List>
        <p>
          <strong>RBI Reference:</strong>{" "}To learn more about the regulatory framework we follow, visit the{" "}
          <a
            href="https://m.rbi.org.in//scripts/BS_ViewMasDirections.aspx?id=12156"
            target="_blank"
            rel="noopener noreferrer"
            style={{color:'blue', textDecoration: 'underline'}}
          >
             RBI Master Directions on PPIs
          </a>
        </p>
      </Section>

      {/* How It Works */}
      <Section>
        <Title>How RewardZoo Works</Title>
        <OrderedList>
          <li>
            <strong>Advertisers Create Tasks:</strong> Advertisers design tasks
            (surveys, ads, activities) to promote their products or gather
            insights.
          </li>
          <li>
            <strong>Users Participate:</strong> Users engage with these tasks
            through the RewardZoo platform and earn points for their
            participation.
          </li>
          <li>
            <strong>Points Are Rewarded:</strong> Points are credited to the
            user's account upon successful task completion.
          </li>
          <li>
            <strong>Redeem Rewards:</strong> Users can securely redeem their
            points into UPI or Paytm wallets as real monetary rewards.
          </li>
        </OrderedList>
      </Section>

      {/* FAQ Section */}
      <Section>
        <Title>FAQ</Title>
        <SubTitle>What is RewardZoo?</SubTitle>
        <p>
          RewardZoo is a virtual rewards platform developed by{" "}
          <strong>CashCoin</strong> and operated by{" "}
          <strong>LEADMINT TECHNOLOGIES PRIVATE LIMITED</strong>. Users can earn
          real monetary rewards by completing surveys, watching ads, and
          performing tasks.
        </p>
        <SubTitle>How are payouts processed?</SubTitle>
        <p>
          Rewards are transferred securely to UPI and Paytm wallets via
          RBI-compliant systems. All transactions are traceable and adhere to
          fraud prevention measures.
        </p>
        <SubTitle>How does RewardZoo ensure compliance?</SubTitle>
        <p>
          RewardZoo operates under RBI’s guidelines for Semi-Closed Prepaid
          Payment Instruments (PPIs). All payouts are handled securely, and only
          verified users can redeem rewards.
        </p>
      </Section>

      {/* Contact Us */}
      <Section>
        <Title>Contact Us</Title>
        <List>
          <li>
            <strong>Email:</strong>{" "}
            <Email href="mailto:rewardzoo@loftlime.com">
              rewardzoo@loftlime.com
            </Email>
          </li>
          <li>
            <strong>Parent Company:</strong>{" "}
            <b>LEADMINT TECHNOLOGIES PRIVATE LIMITED</b>
          </li>
          <li>
            <strong>Developed By:</strong> CashCoin
          </li>
          <li>
            <strong>Address:</strong>2nd Floor , A-18 Bhabha Marg ,Gautambuddha
            Nagar, Noida, Uttar Pradesh 201301, IN
          </li>
        </List>
      </Section>
    </Container>
  );
};

export default RewardZoo;
